import { render, staticRenderFns } from "./InfoStatusAlert.vue?vue&type=template&id=d1d10e06&scoped=true"
import script from "./InfoStatusAlert.vue?vue&type=script&lang=js"
export * from "./InfoStatusAlert.vue?vue&type=script&lang=js"
import style0 from "./InfoStatusAlert.vue?vue&type=style&index=0&id=d1d10e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d10e06",
  null
  
)

export default component.exports